import React, { PureComponent } from 'react'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import FieldWrapper from '../FieldRowWrapper'
import RawHtml from 'stories/components/RawHtml'

export default class TextInput extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputChange = (event) => {
    const { value } = event.target
    this.props.onChange(value)
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  clearInputValue = () => {
    this.props.onChange(' ')
  }

  getInputValue = () => this.props.value

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      required,
      touched,
      error,
      description,
      readOnly,
      SideElement,
      hideTitle,
      autoFocus,
      password,
      clearButton,
      autoComplete = 'on',
      customized,
      fullWidth,
      ltr,
      helperText,
      endAdornment,
      disabled,
    } = this.props

    const classNames = {
      'formz-text-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': fullWidth,
    }

    const inputProps = {
      type: password ? 'password' : 'text',
      name: name,
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      readOnly: readOnly,
      autoFocus: autoFocus,
      autoComplete: autoComplete,
      disabled,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            {!hideTitle && (
              <div className="formz-input-title">
                {label} {required && '(*)'}
              </div>
            )}

            {/* desc */}
            <RawHtml
              className="formz-field-description"
              content={description}
            />
            <input
              className="formz-input-field"
              placeholder={placeholder}
              {...inputProps}
            />
            {clearButton && (
              <div
                className="clear-button"
                onClick={() => {
                  this.clearInputValue()
                }}
              >
                &#10006;
              </div>
            )}
            {SideElement && <SideElement />}
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={fullWidth}
      >
        <TextField
          {...inputProps}
          label={label || placeholder}
          error={Boolean(error)}
          InputProps={{
            startAdornment: SideElement && (
              <InputAdornment position="start">
                <SideElement />
              </InputAdornment>
            ),
            endAdornment: endAdornment && (
              <InputAdornment position="end">{endAdornment}</InputAdornment>
            ),
          }}
          style={{ direction: ltr ? 'ltr' : 'inherit' }}
          helperText={helperText}
        />
      </FieldWrapper>
    )
  }
}
